<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Borç/Alacak</label>
            <v-select-list :options="baTypes" label="name" placeholder="Borç/Alacak" v-model="baType"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Kasa</label>
            <v-select-list   v-model="kasa" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Kod</label>
            <input class="form-control" v-model="value.Code" placeholder="Kod"/>
        </div>
        <div class="col-12">
            <label class="form-label">Tip</label>
            <v-select-list :options="types" label="Name" placeholder="Tip" v-model="type"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import NetsisOperationsApi from '@/api/netsis-operations';

export default {
    props:{
        value:Object
    },
    data(){
        return {
            baTypes:[
                {name:'Borç',value:'B'},
                {name:'Alacak',value:'A'},
            ],
            types:[],
            kasaList:[],
            kasaLoading:false
        }
    },
    mounted(){
        this.getKasaHesapPlaniType()
        this.getKasaList()
    },
    methods:{
        getKasaHesapPlaniType(){
            SystemDataApi.KasaHesapPlaniType().then(res=>{
                this.types = res.data.Data
            })
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                this.kasaList = res.data.Data
                this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
    },
    computed:{
        baType:{
            get:function(){
                return this.baTypes.find(b=>b.value==this.value.B_A)
            },
            set:function(value){
                this.value.B_A = value?.value || null
            }
        },
        type:{
            get:function(){
                return this.types.find(s=>s.Value==this.value.Type)
            },
            set:function(value){
                this.value.Type = value?.Value != null ? value.Value : null
            }
        },
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.value.VaultCode)
            },
            set:function(value){
                this.value.VaultCode = value?.KSMAS_KOD || null
            }
        }
    }
}
</script>